import React, { useEffect, useState } from "react";
import { MenuLateral } from "../../../../Components/MenuLateral/Index";
import { Header } from "../../../../Components/Header";
import { Panel } from "../../../../Components/Panel";
import { useCartorio } from "../../../../Hooks/cartorio";
import { Container } from "./styles";
import api from "../../../../Services/api";
import axios from "axios";
import { TablePanel } from "../../../../Components/TablePanel";
import { Alert } from "../../../../Components/Error/Alert";
import { ModalLoader } from "../../../../Components/ModalLoader";
import {
  IPrefeitura,
  IPrefeituraAssets,
  usePrefeitura,
} from "../../../../Hooks/usePrefeitura";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";

export function Prefeituras() {
  const { cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
  const [index, setIndex] = useState(1 as 1 | 2 | 3);
  const {
    prefeituras,
    getPrefeituras,
    assets,
    prefeiturasNaoLigadas,
  } = usePrefeitura();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });
  const [prefeiturasVisiveis, setprefeiturasVisiveis] = useState(
    {} as IPrefeitura[]
  );
  const [abas, setAbas] = useState([
    {
      title: "ATIVO",
      index: 1,
      execute: () => {
        setIndex(1);
        console.log("ATIVOS");
      },
      data: {},
    },
    {
      title: "PENDENTE",
      index: 2,
      execute: () => {
        setIndex(2);
      },
      data: {},
    },
    {
      title: "GERAL",
      index: 3,
      execute: () => {
        setIndex(3);
        console.log("INVATIVOS");
      },
      data: {},
    },
  ]);

  async function executa() {
    try {
      setLoading(true);
      if (funcionarioCartorioIsLogged) {
        await checarTokenFuncionario();
      } else {
        await checarToken();
      }

      await getPrefeituras(cartorio.ID);
    } catch (error) {
      setError({
        message: "Erro ao carregar prefeituras!",
        title:
          "Não foi possível carregar os imovéis, tente novamente mais tarde!",
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    executa();
  }, [cartorio.ID]);

  useEffect(() => {
      console.log("teste")
    const teste = definePrefeituras();
    if (teste) setprefeiturasVisiveis(teste);
  }, [index,prefeituras,]);

  useEffect(() => {}, []);

  function definePrefeituras() {
    if (prefeituras && prefeiturasNaoLigadas) {
      //if (prefeituras.length > 0) {
        if (index == 1) {
          return prefeituras.filter((item) => {
            if (item.STATUS != null)
              return item.STATUS.trim().toUpperCase() == "A";
          });
        }

        if (index == 2) {
          return prefeituras.filter((item) => {
            if (item.STATUS != null)
              return item.STATUS.trim().toUpperCase() == "P";
          });
        }

        if (index == 3) {
          console.log("aquiiii:", prefeiturasNaoLigadas);
          return prefeiturasNaoLigadas;
        }
      //}
    }
  }
  return (
    <Container>
      <MenuLateral titulo={cartorio.NOME} />
      <Panel
        children={
          <>
            <Header type={"PREFEITURAS"} />
            <TablePanel
              abas={abas}
              index={index}
              loading={true}
              conteudoTabelaPrefeituras={prefeiturasVisiveis}
              conteudoTabelaPrefeiturasAssets={assets}
              tableHeader={[""]}
            />
          </>
        }
      />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
      <ModalLoader loading={loading} />
    </Container>
  );
}
